import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import lodash from "lodash";
import { FormProvider, useForm, useFormContext } from "react-hook-form";

import KogAutoCompleteControlled from "@/main/components/shared/inputAutoComplete/autoCompleteControlled";
import { KeyValue } from "@/main/models/common";
import { getCountriesUser, useCountryReducer } from "@/main/store/country";
import Box from "@/main/components/shared/box";
import KogInputTextControlledNew from "@/main/components/shared/inputText/inputTextControlledNew";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import { BaseTableRowModalSide, KOGTableRowModalSide } from "@/main/components/shared/boxGrid/styles";
import { Table, TableBody, TableCell, TableContainer, TableHead } from "@mui/material";
import { createStyles, withStyles } from "@mui/styles";
import { getStatusRegister } from "@/main/store/statusRegister";
import {
	CompanyFilterRequest,
	ScreenGroups,
	UsergroupSaveControlsRequest,
	UsergroupSaveRequest,
} from "@/main/models/request";
import { SetURLSearchParams, useNavigate, useSearchParams } from "react-router-dom";
import KOGBoxGridCheckbox, { IOptionGridCheckbox } from "@/main/components/shared/boxGridCheckbox/boxGridCheckbox";
import * as StyleShared from "@/main/components/shared/styles";
import KogCheckbox from "@/main/components/shared/checkbox/kogCheckbox";
import {
	getDefaultOptionDrop,
	getTranslateByKey,
	haveIgnoreElement,
	getDefaultCountryOptionDrop,
	isNullUndefined,
} from "@/main/services/utils";
import { userIsAdmin } from "@/main/services/utilsUser";
import { userIsInsurer } from "@/main/services/utilsUser";
import { getCompanyType, useCompanyTypeReducer } from "@/main/store/companyType";
import { getCompany, resetReducerCompany, useCompanyReducer } from "@/main/store/company";
import { HeadQuarterBranchFilterEnum } from "@/main/services/enum/HeadQuarterBranchFilterEnum";
import { CompanyTypeEnum } from "@/main/services/enum/CompanyTypeEnum";
import { controlApi, screenApi, usergroupApi } from "@/main/api";
import KogModalSideComponent from "@/main/components/modal/ModalSide";
import { getOptionsStatus } from "@/main/services/data/data";
import LoadingComponent from "@/main/components/shared/loading/loadingComponent";
import { toast } from "react-toastify";
import ContainerScreen from "@/main/components/shared/containerScreen/containerLayout";
import { useUserReducer } from "@/main/store/user";
import { StatusUserEnum } from "@/main/services/enum/StatusUserEnum";
import { ScreenRegistrationDataResponse } from "@/main/models/response/screenResponse";
import { IUsergroupRegisterForm, UsergroupRegisterProvider, useUsergroupRegisterContext } from "./context";
import * as S from "./styles";
import { StatusRegisterEnum } from "@/main/services/enum/StatusRegisterEnum";
import { ScreenRegistrationRequest } from "@/main/models/request/screenRequest";
import { CustomError } from "@/main/services/class/customError";
import { RoutesConstants } from "@/main/routes/routesConstants";
import { getSystemApplication, useSystemApplicationReducer } from "@/main/store/systemApplication";

interface IUserGroupHeaderModal {
	id: string;
	menu: string;
	screen: string;
	controls: string;
}
interface IFormattedOptions {
	id: string;
	elements: [];
}

interface IValidateForm {
	company?:
		| {
				key: string | null | undefined;
				value: string;
		  }
		| null
		| undefined;
	companyType: {
		key: string;
		value: string;
	};
	country: {
		key: string;
		value: string;
	};
	status: {
		key: number;
		value: string;
	};
	systemApplication?:
		| {
				key: string | null | undefined;
				value: string;
		  }
		| null
		| undefined;

	userGroup: string;
}
interface IVerifyAccess {
	elementId: string;
	guid: string;
	guidScreen: string;
	hasAccess: boolean;
	name: string;
}

interface UserGroupProps {
	setOptionsGroupWithPermissions: Dispatch<SetStateAction<IFormattedOptions | null>>;
	setUserGroupHeaderModal: Dispatch<SetStateAction<IUserGroupHeaderModal | null>>;
	setOpen: Dispatch<SetStateAction<boolean>>;
	guidUsergroup: string | null;
	idSystemApplication: string | null;
	setDataControlScreen: Dispatch<SetStateAction<string[]>>;
	setSearchParams: Dispatch<SetURLSearchParams>;
	setIsLoadingOptions: (isLoadingOptions: boolean) => void;
}

function UsergroupRegisterScreen({
	setOptionsGroupWithPermissions,
	setUserGroupHeaderModal,
	setOpen,
	guidUsergroup,
	idSystemApplication,
	setDataControlScreen,
	setSearchParams,
	setIsLoadingOptions,
}: UserGroupProps) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [dataUsergroup, setDataUsergroup] = useState<string[]>([]);
	const [isLoadingOptionsUsergroup, setIsLoadingOptionsUsergroup] = useState<boolean>(false);
	const [optionsUsergroup, setOptionsUsergroup] = useState<IOptionGridCheckbox[] | null>(null);
	const [isLoadingSave, setIsLoadingSave] = useState<boolean>(false);

	const companyTypeReducer = useCompanyTypeReducer();
	const companyReducer = useCompanyReducer();
	const countryReducer = useCountryReducer();
	const userReducer = useUserReducer();
	const systemApplicationReducer = useSystemApplicationReducer();

	const typeCompanyUser = !userIsAdmin() ? String(userReducer.currentUser?.idCompanyType) : null;

	const optionDefaultCountryDrop = getDefaultCountryOptionDrop(countryReducer.countriesUser.data);
	getDefaultOptionDrop(companyTypeReducer.companyType.data, typeCompanyUser);

	const statusOptionsStatus = getOptionsStatus();

	const rowHeaders = [
		getTranslateByKey("information.registerUsergroupTextMenu"),
		getTranslateByKey("information.registerUsergroupTextScreen"),
		<p key="2" style={{ width: "100%", textAlign: "center", marginBottom: 0 }}>
			{getTranslateByKey("information.registerUsergroupTextControls")}
		</p>,
	];

	const isDisabledCompanyTypeDrop = () =>
		companyTypeReducer.companyType.data === null ||
		!companyTypeReducer.companyType.data ||
		companyTypeReducer.companyType.data.length === 1;

	const isDisabledCompanyDrop = () =>
		getValues().companyType === null ||
		!companyReducer.company.data ||
		companyReducer.company.data.length === 1 ||
		companyReducer.company.data.length === 0;

	const {
		control,
		handleSubmit,
		setValue,
		formState: { errors },
		getValues,
		watch,
	} = useFormContext<IUsergroupRegisterForm>();
	const watcherCompanyType = watch("companyType");
	const watcherCountry = watch("country");

	const watcherSystemApplication = watch("systemApplication");

	const { isEdit, setIsEdit } = useUsergroupRegisterContext();

	useEffect(() => {
		if (guidUsergroup && idSystemApplication) {
			setIsEdit(true);
			loadInfoUsergroupEdit(guidUsergroup, Number(idSystemApplication));
		}
	}, [guidUsergroup, idSystemApplication]);

	useEffect(() => {
		dispatch(getCountriesUser());
		dispatch(getStatusRegister());
		dispatch(
			getCompanyType({
				screenCompanytype: true,
			}),
		);
		dispatch(getSystemApplication());
	}, []);

	// Fill and lock filters for Insurer user
	useEffect(() => {
		const isInsurerUser = userIsInsurer();
		if (!isInsurerUser) return;

		const defaultCountry = getDefaultCountryOptionDrop(countryReducer.countriesUser.data);
		if (defaultCountry) {
			setValue("country", defaultCountry);
		}
	}, [countryReducer.countriesUser.data, companyTypeReducer.companyType.data]);

	useEffect(() => {
		const isInsurerUser = userIsInsurer();
		if (!isInsurerUser || isEdit) return;
		if (companyReducer.company.data && companyReducer.company.data.length > 0) {
			const defaultCompany = getDefaultOptionDrop(companyReducer.company.data);

			if (defaultCompany) {
				setValue("company", defaultCompany);
			}
		}
	}, [companyReducer.company.data]);

	// Load options by type company if user is not admin
	useEffect(() => {
		const companyTypeIsEmpty = !watcherCompanyType?.key;
		const systemApplicationIsEmpty = !watcherSystemApplication?.key;
		if (companyTypeIsEmpty || systemApplicationIsEmpty) {
			loadOptions([]);
			return;
		}
		loadOptionsByCompanyType(watcherCompanyType?.key, watcherSystemApplication?.key);
	}, [JSON.stringify(watcherCompanyType), watcherSystemApplication?.key]);

	useEffect(() => {
		const companyTypeIsEmpty = !watcherCompanyType?.key;
		if (companyTypeIsEmpty || isNullUndefined(watcherCountry)) {
			return;
		}
		callCompanyApiDomain(watcherCountry, watcherCompanyType);
	}, [JSON.stringify(watcherCompanyType), watcherCountry?.key]);

	function loadOptionsByCompanyType(
		companyType: number | string | null | undefined,
		systemApplication: number | string | null | undefined,
	) {
		const request: ScreenRegistrationRequest = {
			...(guidUsergroup && { guidGroup: guidUsergroup }),
			...(companyType && { idCompanyType: Number(companyType) }),
			...(systemApplication && {
				idSystemApplication: Number(systemApplication),
			}),
		};
		setOptionsUsergroup(null);
		setIsLoadingOptionsUsergroup(true);

		screenApi.getByGroupWithPermissions(request).then((response) => {
			const resultData = response.data.result;
			const guidsResultData = resultData.map((item) => item.guid);

			setIsLoadingOptionsUsergroup(false);
			setDataUsergroup((prev) => {
				if (prev.length === 0) return prev;
				const onlyExistsResult = prev.filter((item) => guidsResultData.includes(item));
				return onlyExistsResult;
			});
			loadOptions(resultData);
		});
	}

	function loadInfoUsergroupEdit(guidUsergroupRequest: string, idSystemApplicationRequest: number) {
		setIsLoadingOptionsUsergroup(true);
		usergroupApi
			.getRegistrationDataUsergroup({
				guidUsergroup: guidUsergroupRequest,
				idSystemApplication: idSystemApplicationRequest,
			})
			.then((response) => {
				const resultData = response.data.result;
				setValue("country", {
					key: resultData.country.guid,
					value: resultData.country.name,
				});
				setValue("companyType", {
					key: resultData.companyType.idCompanyType,
					value: resultData.companyType.name,
				});
				if (resultData.companyData) {
					setValue("company", {
						key: resultData.companyData.guidCompany,
						value: resultData.companyData.companyName,
					});
				}
				setValue("userGroup", resultData.name);
				if (resultData.systemApplication) {
					setValue("systemApplication", {
						key: resultData.systemApplication.idSystemApplication,
						value: resultData.systemApplication.name,
					});
				}
				const key = resultData.active === true ? StatusUserEnum.Active : StatusUserEnum.Suspended;
				const findStatus = getOptionsStatus().find((item) => item.key === key);
				setValue("status", findStatus);
			});
	}

	function verifyAccess(data: IOptionGridCheckbox[], dataSelect: []) {
		const result = [];

		for (let i = 0; i < data.length; i++) {
			const item = data[i];
			const hasAccess = dataSelect.includes(item.id);
			result.push({ GuidScreen: item.id, HasAccess: hasAccess });
		}

		return result;
	}

	function validateForm(data: IValidateForm) {
		const messages = [];
		if (!data.country) messages.push(getTranslateByKey("information.mustHaveAtLeastOneCountry", true));
		if (!data.companyType) messages.push(getTranslateByKey("information.mustHaveAtLeastOneCompanyType", true));
		if (data.userGroup.length === 0) messages.push(getTranslateByKey("information.mustHaveAtLeastOneUsergroup", true));
		if (!data.status) messages.push(getTranslateByKey("information.mustHaveAtLeastOneStatus", true));

		if (messages.length > 0) {
			messages.map((message) => toast.error(message));
			throw new CustomError(messages.join("/n"), "MISSING_FIELDS");
		}
		return true;
	}
	const formattedDataUsergroup = (data: IValidateForm, resultVerification: ScreenGroups[]) => {
		const dataReturn: UsergroupSaveRequest = {
			guid: guidUsergroup,
			guidCountry: data.country.key,
			guidCompany: data?.company?.key,
			idCompanyType: Number.parseInt(String(data?.companyType?.key)),
			name: data.userGroup,
			active: data.status.key === StatusUserEnum.Active,
			idSystemApplication: Number.parseInt(String(data?.systemApplication?.key)),
			ScreenGroups: resultVerification,
			guidCompanyInsurer:
				userReducer.currentUser?.idCompanyType == CompanyTypeEnum.Insurer ? userReducer.currentUser?.guidCompany : null,
		};
		return dataReturn;
	};
	function handleSubmitSaveUsergroup(e: any) {
		if (!validateForm(e)) return;
		setIsLoadingSave(true);
		const resultVerification = verifyAccess(optionsUsergroup, dataUsergroup);
		const formattedUsergroup: UsergroupSaveRequest = formattedDataUsergroup(e, resultVerification);
		usergroupApi
			.saveUsergroup(formattedUsergroup)
			.then((response) => {
				if (response && response.data && response.data.result) {
					toast.success(getTranslateByKey("information.usegroupSavedSuccessfully"));
					setSearchParams(
						{
							usergroupGuid: response.data.result.guid,
							idSystemApplication: getValues("systemApplication.key"),
						},
						{ replace: true },
					);
				}
			})
			.finally(() => setIsLoadingSave(false));
	}

	function callCompanyApiDomain(countrySelected: KeyValue | null, companyTypeSelected: KeyValue | null) {
		if (!isEdit) {
			setValue("company", null);
		}
		dispatch(resetReducerCompany());

		if (countrySelected !== null && !isEdit) {
			// If the user is an insurer and the selected company is of another type, show only companies exclusively related to that insurer
			const isInsurerUser = userReducer.currentUser?.idCompanyType == CompanyTypeEnum.Insurer;

			const seeOnlyCompaniesWithAnAgreement =
				isInsurerUser && Number(companyTypeSelected?.key) !== CompanyTypeEnum.Insurer ? true : false;
			const seeOnlyExclusiveAgreement = seeOnlyCompaniesWithAnAgreement;

			const request: CompanyFilterRequest = {
				guidCountry: String(countrySelected.key),
				type: HeadQuarterBranchFilterEnum.All,
				idStatusRegister: StatusRegisterEnum.Active,
				seeOnlyCompaniesWithAnAgreement: seeOnlyCompaniesWithAnAgreement,
				seeOnlyExclusiveAgreement: seeOnlyExclusiveAgreement,
				guidCompany: isInsurerUser ? userReducer.currentUser?.guidCompany : null,
			};
			if (companyTypeSelected) {
				request.idCompanyType = String(companyTypeSelected.key);
			}
			dispatch(getCompany(request));
		}
	}

	function handleBack() {
		navigate(RoutesConstants.registrationSearchUsergroup);
	}

	function loadOptions(data: ScreenRegistrationDataResponse[]) {
		const formattedOptions = data.map((option) => {
			if (option.hasAccess) {
				setDataUsergroup((prevData) => [...prevData, option.guid]);
			}
			const checkOpenModal = (option.hasAccess || dataUsergroup.includes(option.guid)) && option.controlsCount !== 0;

			return {
				id: option.guid,
				elements: [
					{
						content: <S.RowGrid cursorPointer={checkOpenModal}>{option.module.name}</S.RowGrid>,
						width: "40%",
					},
					{
						content: <S.RowGrid cursorPointer={checkOpenModal}>{option.name}</S.RowGrid>,
						width: "50%",
					},
					{
						content: (
							<S.RowGrid cursorPointer={checkOpenModal}>
								<p
									style={{
										width: "100%",
										textAlign: "center",
										marginBottom: 0,
										textDecoration: checkOpenModal ? "underline" : "none",
									}}
								>
									{option.controlsCount}
								</p>
							</S.RowGrid>
						),
						width: "10%",
					},
				],
			};
		});

		setOptionsUsergroup(formattedOptions);
	}

	function handleSetHeaderModal(modalSelect: IFormattedOptions) {
		const formattedHeaderModal = {
			id: modalSelect.id,
			menu: modalSelect.elements[0].content,
			screen: modalSelect.elements[1].content,
			controls: modalSelect.elements[2].content,
		};
		setUserGroupHeaderModal(formattedHeaderModal);
	}

	function openModal(user: IFormattedOptions) {
		const companyType = getValues().companyType;
		const idCompanyType: number = companyType && companyType.key ? Number(companyType.key) : 0;
		const systemApplication = getValues().systemApplication;
		const idsystemApplication: number = systemApplication && systemApplication.key ? Number(systemApplication.key) : 0;
		setOpen(true);
		setIsLoadingOptions(true);
		controlApi
			.getByGroupWithPermissions({
				guidUsergroup,
				guidScreen: user.id,
				idCompanyType,
				idsystemApplication,
			})
			.then((response) => {
				const resultData = response.data.result;
				const checkedDataControlScreen = [];
				resultData.map((data) => {
					if (data.hasAccess) {
						checkedDataControlScreen.push(data.guid);
					}
				});
				setDataControlScreen(checkedDataControlScreen);
				setOptionsGroupWithPermissions(resultData);
			})
			.finally(() => setIsLoadingOptions(false));
	}

	return (
		<>
			<ContainerScreen
				title={`
      ${getTranslateByKey("information.registration")}
      ${" > "}
      ${getTranslateByKey("information.registerUsergroup")}`}
			>
				<Box title="Filters">
					<S.RowInputs>
						<KogAutoCompleteControlled
							required
							label={getTranslateByKey("information.country")}
							control={control}
							options={countryReducer.countriesUser.data}
							isLoading={countryReducer.countriesUser.isLoading}
							nameCustom="country"
							id="id-usergroupRegistration-select-country"
							rulesCustom={{ required: true }}
							errorMessageCustom={
								errors.country?.type === "required" ? getTranslateByKey("information.countryRequired", true) : ""
							}
							hasErrorCustom={!!errors.country}
							onChangeCustom={(optionSelected: KeyValue | null) => {
								setValue("country", optionSelected);
							}}
							autoHighlightCustom={!!optionDefaultCountryDrop}
							setValueCustom={setValue}
							disabled={isEdit || userIsInsurer() || optionDefaultCountryDrop !== null}
						/>
						<KogAutoCompleteControlled
							required
							label={getTranslateByKey("information.companyType")}
							control={control}
							options={companyTypeReducer.companyType.data}
							isLoading={companyTypeReducer.companyType.isLoading}
							nameCustom="companyType"
							id="id-usergroupRegistration-select-companyType"
							isDefaultValueUnique
							rulesCustom={{ required: true }}
							errorMessageCustom={
								errors.companyType?.type === "required"
									? getTranslateByKey("information.companyTypeRequired", true)
									: ""
							}
							setValueCustom={setValue}
							hasErrorCustom={!!errors.companyType}
							disabled={isEdit ? isEdit : isDisabledCompanyTypeDrop()}
							onChangeCustom={() => {}}
						/>
						<KogAutoCompleteControlled
							label={getTranslateByKey("information.company")}
							control={control}
							isDefaultValueUnique
							nameCustom="company"
							id="id-usergroupRegistration-select-company"
							rulesCustom={{ required: false }}
							errorMessageCustom=""
							hasErrorCustom={false}
							options={companyReducer.company.data}
							isLoading={companyReducer.company.isLoading}
							onChangeCustom={() => {}}
							disabled={isEdit ? isEdit : isDisabledCompanyDrop()}
							setValueCustom={setValue}
						/>
					</S.RowInputs>
					<S.RowInputs>
						<KogAutoCompleteControlled
							id="id-searchUserGroup-select-system"
							label={getTranslateByKey("information.systemApplication")}
							control={control}
							nameCustom="systemApplication"
							rulesCustom={{ required: true }}
							errorMessageCustom=""
							hasErrorCustom={false}
							options={systemApplicationReducer.systemApplication.data}
							isLoading={systemApplicationReducer.systemApplication.isLoading}
							onChangeCustom={() => {}}
							disabled={isEdit}
							setValueCustom={setValue}
						/>
						<KogInputTextControlledNew
							name="userGroup"
							id="id-usergroupRegistration-text-usergroup-register"
							label={getTranslateByKey("information.userGroup")}
							errorMessageCustom={
								errors.userGroup?.type === "required" ? getTranslateByKey("information.usergroupRequired", true) : ""
							}
							controllerProps={{
								rules: {
									required: true,
									maxLength: 200,
								},
							}}
							control={control}
						/>
						<KogAutoCompleteControlled
							label={getTranslateByKey("information.status")}
							nameCustom="status"
							id="id-usergroupRegistration-select-statusRegister"
							errorMessageCustom={
								errors.status?.type === "required" ? getTranslateByKey("information.statusRequired", true) : ""
							}
							onChangeCustom={() => {}}
							control={control}
							setValueCustom={setValue}
							options={statusOptionsStatus}
							rulesCustom={{ required: true }}
							valueDefaultKey={statusOptionsStatus[0].key}
							hasErrorCustom={!!errors.status}
						/>
					</S.RowInputs>
					<StyleShared.KOGAreaButtons>
						<SecondaryButton
							id="id-usergroupRegistration-button-save"
							type="submit"
							disabled={!(dataUsergroup.length > 0) || isLoadingSave}
							isLoading={isLoadingSave}
							onClick={handleSubmit(handleSubmitSaveUsergroup)}
						>
							{getTranslateByKey("information.save")}
						</SecondaryButton>

						<SecondaryButton id="id-usergroupRegistration-button-back" onClick={handleBack}>
							{getTranslateByKey("information.back")}
						</SecondaryButton>
					</StyleShared.KOGAreaButtons>
				</Box>
			</ContainerScreen>

			<S.Container>
				{isLoadingOptionsUsergroup ? (
					<LoadingComponent />
				) : (
					optionsUsergroup &&
					optionsUsergroup.length > 0 && (
						<S.AreaOptions>
							<StyleShared.HeaderText>
								{getTranslateByKey("information.registerUsergroupTitleGridSreens")}
							</StyleShared.HeaderText>
							<KOGBoxGridCheckbox
								rowHeaders={rowHeaders}
								options={optionsUsergroup}
								optionsSelected={dataUsergroup}
								setOptionsSelected={setDataUsergroup}
								onChangeCustom={(optionsSelected) => {
									setDataUsergroup(optionsSelected);
								}}
								onClickCustom={(option, event) => {
									const POSITION_COLUMN_GRID = option.elements[2];
									if (isEdit && POSITION_COLUMN_GRID) {
										const COUNT_CONTROLS = POSITION_COLUMN_GRID.content.props.children.props.children;
										if (haveIgnoreElement(event.target as HTMLElement)) return;
										const findOptionSelect = optionsUsergroup.find(
											(optionUsergroup) => optionUsergroup.id === option.id,
										);
										if (findOptionSelect && dataUsergroup.includes(option.id) && COUNT_CONTROLS > 0) {
											handleSetHeaderModal(option);
											openModal(option);
										}
									}
								}}
							/>
						</S.AreaOptions>
					)
				)}
			</S.Container>
		</>
	);
}

export default function UsergroupRegisterScreenLoaded() {
	const [searchParams, setSearchParams] = useSearchParams();
	const guidUsergroup = searchParams.get("usergroupGuid");
	const idSystemApplication = searchParams.get("idSystemApplication");
	const [open, setOpen] = useState<boolean>(false);
	const [isLoadingOptions, setIsLoadingOptions] = useState<boolean>(false);
	const [optionsGroupWithPermissions, setOptionsGroupWithPermissions] = useState<IFormattedOptions | null>(null);
	const [userGroupHeaderModal, setUserGroupHeaderModal] = useState<IUserGroupHeaderModal | null>(null);
	const [dataControlScreen, setDataControlScreen] = useState<string[]>([]);

	const rowHeadersModal = [
		getTranslateByKey("information.registerUsergroupTextDescription"),
		getTranslateByKey("information.registerUsergroupTextVisible"),
	];

	const StyledTableCell = withStyles(() =>
		createStyles({
			head: {
				color: "#7e7e7e",
				fontWeight: "bold",
			},
			body: {
				fontSize: 14,
				color: "#000",
			},
		}),
	)(TableCell);

	function closeModal() {
		setOptionsGroupWithPermissions(null);
		setOpen(false);
	}

	function handleToggleCheckbox(guid: string) {
		const cloneOptionsSelected = lodash.cloneDeep(dataControlScreen);
		const index = cloneOptionsSelected?.indexOf(guid);

		if (index > -1) {
			cloneOptionsSelected?.splice(index, 1);
		} else {
			cloneOptionsSelected?.push(guid);
		}
		setDataControlScreen(cloneOptionsSelected);
	}

	const methods = useForm();

	function verifyAccessControls(data: IVerifyAccess, dataSelect: string[]) {
		const result = [];

		for (let i = 0; i < data.length; i++) {
			const item = data[i];
			const hasAccess = dataSelect.includes(item.guid);
			result.push({ GuidControl: item.guid, HasAccess: hasAccess });
		}

		return result;
	}
	function handleSubmitModal() {
		const resultVerification = verifyAccessControls(optionsGroupWithPermissions, dataControlScreen);
		const formattedDataUsergroupControls: UsergroupSaveControlsRequest = {
			guidUsergroup,
			controls: resultVerification,
		};
		usergroupApi.saveSaveControlsUsergroup(formattedDataUsergroupControls).then(() => {
			toast.success(getTranslateByKey("information.usegroupControlSavedSuccessfully"));
			closeModal();
		});
	}

	return (
		<>
			<UsergroupRegisterProvider>
				<UsergroupRegisterScreen
					setOptionsGroupWithPermissions={setOptionsGroupWithPermissions}
					setUserGroupHeaderModal={setUserGroupHeaderModal}
					setOpen={setOpen}
					guidUsergroup={guidUsergroup}
					idSystemApplication={idSystemApplication}
					setDataControlScreen={setDataControlScreen}
					setSearchParams={setSearchParams}
					setIsLoadingOptions={setIsLoadingOptions}
				/>
			</UsergroupRegisterProvider>

			{guidUsergroup && idSystemApplication && (
				<KogModalSideComponent open={open} closeModal={() => closeModal()}>
					{isLoadingOptions ? (
						<LoadingComponent />
					) : (
						<FormProvider {...methods}>
							<form>
								<S.Title>{getTranslateByKey("information.registerUsergroupTitleModalSide")}</S.Title>
								<S.BoxModal>
									<div style={{ marginBottom: "5px" }}>
										<S.TextScreen>{getTranslateByKey("information.registerUsergroupTextMenu")}:</S.TextScreen>{" "}
										<strong>{userGroupHeaderModal?.menu}</strong>
									</div>
									<div style={{ marginBottom: "5px" }}>
										<S.TextScreen>{getTranslateByKey("information.registerUsergroupTextScreen")}:</S.TextScreen>{" "}
										<strong>{userGroupHeaderModal?.screen}</strong>
									</div>

									<TableContainer>
										<Table aria-label="customized table">
											<TableHead>
												<BaseTableRowModalSide>
													{rowHeadersModal &&
														rowHeadersModal.map((header, index) => (
															<StyledTableCell key={index}>{header}</StyledTableCell>
														))}
												</BaseTableRowModalSide>
											</TableHead>
											<TableBody>
												{optionsGroupWithPermissions?.map((group) => (
													<KOGTableRowModalSide key={group.guid}>
														<TableCell width="90%">
															<S.TextScreen>{group.name}</S.TextScreen>
														</TableCell>
														<TableCell width="10%">
															<KogCheckbox
																value={group.guid}
																checked={dataControlScreen.includes(group.guid)}
																onChange={() => handleToggleCheckbox(group.guid)}
																id="id-usergroupRegistration-controls-checkbox"
															/>
														</TableCell>
													</KOGTableRowModalSide>
												))}
											</TableBody>
										</Table>
									</TableContainer>
								</S.BoxModal>

								<div className="d-flex justify-content-center">
									<SecondaryButton
										type="button"
										onClick={closeModal}
										style={{ marginRight: 20 }}
										id="id-usergroupRegistration-controls-button-back"
									>
										{getTranslateByKey("information.back")}
									</SecondaryButton>
									<SecondaryButton
										type="submit"
										onClick={methods.handleSubmit(handleSubmitModal)}
										id="id-usergroupRegistration-controls-button-save"
									>
										{getTranslateByKey("information.save")}
									</SecondaryButton>
								</div>
							</form>
						</FormProvider>
					)}
				</KogModalSideComponent>
			)}
		</>
	);
}
